import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin, Calculator } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_mixology-admin/artifacts/a22ywdhy_iltuoamaro-white%401000x.webp" 
                alt="Il Tuo Amaro" 
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-gray-300 text-sm mb-6 max-w-sm">
              Liquori personalizzati di alta qualità. Crea il tuo amaro o liquore unico con ingredienti premium selezionati.
            </p>
            
            {/* Social Links */}
            <div className="mb-6">
              <h4 className="text-white font-semibold mb-3 text-sm">Seguici</h4>
              <div className="flex space-x-3">
                <a 
                  href="#" 
                  className="w-10 h-10 bg-gray-800 hover:bg-purple-600 rounded-lg flex items-center justify-center transition-colors"
                  aria-label="Facebook"
                >
                  <Facebook className="w-5 h-5" />
                </a>
                <a 
                  href="#" 
                  className="w-10 h-10 bg-gray-800 hover:bg-purple-600 rounded-lg flex items-center justify-center transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram className="w-5 h-5" />
                </a>
                <a 
                  href="#" 
                  className="w-10 h-10 bg-gray-800 hover:bg-purple-600 rounded-lg flex items-center justify-center transition-colors"
                  aria-label="Twitter"
                >
                  <Twitter className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>

          {/* Prodotti */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Prodotti</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/builder" className="text-gray-300 hover:text-purple-400 transition-colors text-sm flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Crea il Tuo Liquore</span>
                </Link>
              </li>
              <li>
                <Link to="/servizi" className="text-gray-300 hover:text-purple-400 transition-colors text-sm flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Come Funziona</span>
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-300 hover:text-purple-400 transition-colors text-sm flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Gallery Liquori</span>
                </Link>
              </li>
              <li>
                <Link to="/campioni" className="text-gray-300 hover:text-purple-400 transition-colors text-sm flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Campioni</span>
                </Link>
              </li>
              <li>
                <Link to="/modelli-etichette" className="text-gray-300 hover:text-purple-400 transition-colors text-sm flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Modelli Etichette</span>
                </Link>
              </li>
              <li>
                <Link to="/listino" className="text-gray-300 hover:text-purple-400 transition-colors text-sm flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Listino Prezzi</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Azienda */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Azienda</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/distilleria" className="text-gray-300 hover:text-purple-400 transition-colors text-sm flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">La Distilleria</span>
                </Link>
              </li>
              <li>
                <Link to="/hai-un-progetto" className="text-gray-300 hover:text-purple-400 transition-colors text-sm flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Hai un Progetto?</span>
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-purple-400 transition-colors text-sm flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">FAQ</span>
                </Link>
              </li>
              <li>
                <Link to="/contatti" className="text-gray-300 hover:text-purple-400 transition-colors text-sm flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Contattaci</span>
                </Link>
              </li>
              <li>
                <Link to="/diventa-agente" data-testid="footer-lavora-con-noi"
                  className="text-gray-300 hover:text-purple-400 transition-colors text-sm flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Lavora con noi</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Risorse & Contatti */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Risorse</h3>
            <ul className="space-y-2.5 mb-6">
              <li>
                <Link to="/calcolatore-guadagni" className="text-gray-300 hover:text-purple-400 transition-colors text-sm flex items-center group">
                  <Calculator className="w-3.5 h-3.5 mr-1.5" />
                  <span className="group-hover:translate-x-1 transition-transform">Calcolatore Guadagni</span>
                </Link>
              </li>
              <li>
                <Link to="/spedizioni" className="text-gray-300 hover:text-purple-400 transition-colors text-sm flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Spedizioni</span>
                </Link>
              </li>
            </ul>

            <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">Contatti</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="mailto:info@iltuoamaro.it" className="flex items-start space-x-2 text-sm text-gray-300 hover:text-purple-400 transition-colors group">
                  <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  <span className="group-hover:underline">info@iltuoamaro.it</span>
                </a>
              </li>
              <li>
                <a href="tel:+393939587340" className="flex items-start space-x-2 text-sm text-gray-300 hover:text-purple-400 transition-colors group">
                  <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  <span className="group-hover:underline">+39 393 9587340</span>
                </a>
              </li>
              <li>
                <div className="flex items-start space-x-2 text-sm text-gray-300">
                  <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  <span>Via G. Mercalli, 16 Z.I.<br />88900 Crotone (KR)</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col lg:flex-row justify-between items-center space-y-6 lg:space-y-0 gap-6">
            {/* Company Details */}
            <div className="text-gray-400 text-xs text-center lg:text-left space-y-1">
              <p className="font-semibold text-sm">© 2024 Lacinio SRL - IlTuoAmaro.it</p>
              <p>P.IVA: 03714460791 | REA: KR - 184420</p>
              <p>Licenza Doganale: IT00KRX00033F</p>
            </div>

            {/* Legal Links */}
            <div className="flex flex-wrap justify-center lg:justify-end gap-4 lg:gap-6 text-center">
              <Link to="/termini" className="text-gray-400 hover:text-purple-400 transition-colors text-xs font-medium">
                Termini e Condizioni
              </Link>
              <Link to="/privacy-policy" className="text-gray-400 hover:text-purple-400 transition-colors text-xs font-medium">
                Privacy Policy
              </Link>
              <Link to="/cookie-policy" className="text-gray-400 hover:text-purple-400 transition-colors text-xs font-medium">
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;